import {useUserStore} from '~/store/user';
import {getActiveInvitationRoute, getInvitationExitRoute} from '~/utils/invitationNavigation';
import {InvitationStep} from '~~/api/models';

export default defineNuxtRouteMiddleware(async (to) => {
  if (to.name?.toString().includes('invitation')) return;

  const userStore = useUserStore();

  if (import.meta.server && userStore.isAuthenticated && !userStore.userIsFetched) {
    try {
      await userStore.fetchUser();
    } catch {
      return;
    }
  }

  if (!userStore.isAuthenticated || !userStore.user?.activeInvitation) return;
  if (to.name === 'auth-enable-mfa' && userStore.user.activeInvitation.step === InvitationStep.TwoFactor) return;

  const navigationPath = getActiveInvitationRoute(
    userStore.user.activeInvitation,
    getInvitationExitRoute(userStore.isAuthenticated)
  );

  if (navigationPath) return navigateTo(navigationPath);
});